const ABOUT_IMAGE = 'https://readdy.ai/api/search-image?query=neatly%20organized%20used%20tires%20stacked%20on%20industrial%20metal%20shelving%20racks%20in%20a%20clean%20warehouse%2C%20rows%20of%20tires%20sorted%20by%20size%2C%20professional%20tire%20storage%20facility%2C%20indoor%20warehouse%20lighting%2C%20automotive%20parts%20storage%2C%20quality%20management%20and%20inventory%20control%2C%20clean%20organized%20industrial%20space%2C%20dark%20background%2C%20professional%20business&width=900&height=700&seq=202&orientation=portrait';

export default function AboutSection() {
  return (
    <section
      id="about"
      className="py-20 md:py-28"
      style={{ backgroundColor: '#111111', borderTop: '1px solid rgba(255,255,255,0.06)' }}
      aria-label="会社概要"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 md:gap-20">

          {/* Left: Image */}
          <div className="w-full lg:w-[45%] relative flex-shrink-0">
            <div
              className="relative overflow-hidden"
              style={{ aspectRatio: '4/3' }}
            >
              <img
                src={ABOUT_IMAGE}
                alt="整然と整理された中古タイヤの在庫"
                className="w-full h-full object-cover object-top"
              />
              {/* Overlay */}
              <div
                className="absolute inset-0"
                style={{ backgroundColor: 'rgba(26,26,26,0.15)' }}
              />
              {/* Label */}
              <div
                className="absolute top-4 left-4 px-3 py-1.5 text-xs font-bold tracking-widest uppercase"
                style={{
                  backgroundColor: '#f5a623',
                  color: '#1a1a1a',
                  fontFamily: '"Oswald", sans-serif',
                }}
              >
                ABOUT US
              </div>
            </div>

            {/* Decorative frame offset */}
            <div
              className="absolute -bottom-4 -right-4 w-full h-full -z-10"
              style={{ border: '2px solid rgba(245,166,35,0.2)' }}
            />
          </div>

          {/* Right: Text */}
          <div className="flex-1">
            <p
              className="text-xs font-bold tracking-widest mb-4"
              style={{ color: '#f5a623', fontFamily: '"Oswald", sans-serif', letterSpacing: '4px' }}
            >
              About baba Kaba
            </p>
            <h2
              className="text-3xl md:text-4xl font-black mb-4"
              style={{ color: '#ffffff', fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              baba Kabaについて
            </h2>
            <div className="w-12 h-1 mb-8" style={{ backgroundColor: '#f5a623' }} />

            <p
              className="text-base leading-loose mb-6"
              style={{ color: 'rgba(255,255,255,0.82)', fontFamily: '"Noto Sans JP", sans-serif', lineHeight: '2.0' }}
            >
              baba Kabaは東京都青梅市を拠点に、良質な中古タイヤを<strong style={{color:'#f5a623'}}>適正価格</strong>でご提供する専門店です。
            </p>
            <p
              className="text-base leading-loose mb-8"
              style={{ color: 'rgba(255,255,255,0.82)', fontFamily: '"Noto Sans JP", sans-serif', lineHeight: '2.0' }}
            >
              スタッフ一同、お客様の安全なカーライフをサポートするため、丁寧な対応を心がけております。仕入れから販売まで一貫して自社で行うことで、<strong style={{color:'#f5a623'}}>中間マージンのない適正価格</strong>を実現しています。
            </p>

            {/* Values */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: 'ri-shield-check-fill', text: '品質・安全を最優先' },
                { icon: 'ri-hand-heart-fill', text: '丁寧・誠実な対応' },
                { icon: 'ri-map-pin-2-fill', text: '青梅市・周辺地域に密着' },
                { icon: 'ri-recycle-fill', text: '環境への配慮' },
              ].map((val) => (
                <div key={val.text} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className={`${val.icon} text-lg`} style={{ color: '#f5a623' }}></i>
                  </div>
                  <span
                    className="text-sm font-medium"
                    style={{ color: 'rgba(255,255,255,0.8)', fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    {val.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}